export default __webpack_public_path__ + "static/media/White Hand Gem of Unholy Strike.7145f912.jpg";